var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { AuthenticationApiActions, LoginPageActions } from '@app/auth/actions';
export var initialState = {
    error: null,
    pending: false,
};
export function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case LoginPageActions.LoginPageActionTypes.Login: {
            return __assign({}, state, { error: null, pending: true });
        }
        case AuthenticationApiActions.AuthenticationApiActionTypes.LoginSuccess: {
            return __assign({}, state, { error: null, pending: false });
        }
        case AuthenticationApiActions.AuthenticationApiActionTypes.LoginFailure: {
            return __assign({}, state, { error: action.payload.error, pending: false });
        }
        default: {
            return state;
        }
    }
}
export var getError = function (state) { return state.error; };
export var getPending = function (state) { return state.pending; };
